import FormModal from "../../components/modals/form-modal/FormModal";
import styled from "@emotion/styled";
import BtnSimple from "../../components/buttons/BtbSimple";
import { I_RealestateCard } from "../../model/interface/realestate-card.interface";
import React, { FC, useEffect, useMemo } from "react";
import RealEstateCardMinify from "../../components/cards/real-estate-card/RealEstateCardMinify";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { RefererContext } from "./RefererProperties.context";
import { Formik, FormikConfig, FormikHelpers } from "formik";
import TextSimple from "../../components/typography/text-simple/TextSimple";
import ChipInput from "../../components/fields/input-chips/InputChips";
import TextAreaField from "../../components/fields/text-area-field/TextAreaField";
import { useRefererPropertyMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import toast from "react-hot-toast";
import * as yup from "yup";
interface IRealEstateCardInfoProps {
  id: string;
  title: string;
  btnToggle?: any;
  handleDelete?: (item: I_RealestateCard) => void;
  refererContext?: RefererContext;
}

const RealEstateCardInfo: FC<IRealEstateCardInfoProps> = props => {
  return (
    <FormModal
      FormComponent={<AlertContent {...props} />}
      title={props.title}
      btnToggle={props.btnToggle}
      style={{
        padding: 0,
        width: "60%",
        height: "80vh"
      }}
      styleDialogContent={{
        padding: 0,
        width: "100%",
        height: "80vh",
        overflow: "hidden",
        background: "var(--m-color-gray-01)",
        paddingRight: "0"
      }}
    />
  );
};

export default RealEstateCardInfo;

interface IAlertContentProps extends IRealEstateCardInfoProps {
  modalToggle?: () => void;
}

const AlertContent: FC<IAlertContentProps> = props => {
  const [REFERER_PROPERTY_M] = useRefererPropertyMutation();

  const Properties = useMemo(
    () => props.refererContext?.values ?? [],
    [props.refererContext?.values]
  );

  const handleClose = () => {
    if (props.modalToggle) {
      props.modalToggle();
    }
  };
  const handleRemove = (item: I_RealestateCard) => {
    if (props.refererContext) {
      if (props.refererContext.values.length == 1) {
        props.refererContext.clearProperties();
        handleClose();
      } else {
        props.refererContext.removeProperty(item);
      }
    }
  };

  const handleSubmmit = (values: any, h: FormikHelpers<any>) => {
    REFERER_PROPERTY_M({
      body: {
        emails: values.contacts,
        message: values.comment,
        referRealEstateId:
          props.refererContext?.allSelectedIds.map(x => x.toString()) ??
          [],
        subject: "Referencia de propiedades"
      }
    })
      .unwrap()
      .then(() => {
        toast.success("Propiedades referidas con éxito");
        handleClose();
        h.resetForm();
        props.refererContext?.clearProperties();
        props.refererContext?.setFloatMode(true);
      })
      .catch(err => {
        toast.error("Error al referir propiedades");
      });
  };

  const cancelReferer = (h: FormikHelpers<any>) => {
    h.resetForm();
    handleClose();
    props.refererContext?.clearProperties();
    props.refererContext?.setFloatMode(true);
  };

  const setup: FormikConfig<any> = {
    ...configForm,
    onSubmit: handleSubmmit,
    onReset: () => {}
  };

  useEffect(() => {
    return () => {
      // Al cerrar el modal, se quedara activado el botón cuando hallan propiedades seleccionadas
      if (
        props?.refererContext?.values &&
        props?.refererContext?.values.length >= 1
      ) {
        props.refererContext?.setFloatMode(true);
      }
    };
  }, []);

  useEffect(() => {}, []);

  return (
    <ContainerFields>
      <ContainerGrid>
        {Properties.map(item => (
          <ContentActions
            key={window.crypto.getRandomValues(new Uint32Array(1))[0]}
          >
            <CustomIconButton onClick={() => handleRemove(item)}>
              <CloseIcon />
            </CustomIconButton>
            <RealEstateCardMinify
              useContext={false}
              useMenu={false}
              useCheck={false}
              data={item as any}
            />
          </ContentActions>
        ))}
      </ContainerGrid>

      <ContainerForm>
        <Formik {...setup}>
          {formikProps => {
            return (
              <>
                <TextSimple
                  size="label"
                  color="blue"
                  weight="700"
                  sx={{ marginLeft: 2 }}
                >
                  Agrega los correos electrónicos
                </TextSimple>

                <ChipInput name="contacts" label="Referir a" />

                <TextAreaField
                  name="comment"
                  label="Comentario"
                  placeholder="Agregue un comentario"
                />

                <ContainerButtons>
                  <BtnSimple
                    variant-custom="red"
                    onClick={() => cancelReferer(formikProps)}
                  >
                    cancelar
                  </BtnSimple>
                  <BtnSimple
                    variant-custom="blue-main"
                    onClick={() => formikProps.submitForm()}
                  >
                    Referir
                  </BtnSimple>
                </ContainerButtons>
              </>
            );
          }}
        </Formik>
      </ContainerForm>
    </ContainerFields>
  );
};

const ContainerFields = styled.div`
  padding: 0px;
  display: grid;
  grid-template-columns: 70% 30%;
  width: 100%;
  height: 400px;
  @media screen and (max-width: 950px) {
    grid-template-columns: 100%;
  }
`;

const ContentActions = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  padding: 10px;
  padding-top: 50px;
  grid-gap: 10px;
  background-color: white;
  min-height: 71vh;
  @media screen and (max-width: 950px) {
    min-height: auto;
    padding-top: 10px;
    height: 200px;
  }
`;

const ContainerGrid = styled.div`
  padding-top: 10px;
  padding: 10px;
  // padding-right:  20px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  @media screen and (max-width: 950px) {
    grid-template-columns: repeat(1, 1fr);
    overflow: auto;
    justify-content: center;
    align-items: center;
    justify-items: center;
  }
  background-color: var(--m-color-gray-01);
  overflow: hidden;
  overflow-y: auto;
  & > div {
    @media screen and (max-width: 1500px) {
      min-width: 170px;
    }

    @media screen and (max-width: 1400px) {
      min-width: 150px;
    }
    max-width: 90%;
  }
`;

const CustomIconButton = styled(IconButton)`
  position: absolute;
  z-index: 2000;
  right: -5px;
  top: -5px;
  width: 20px;
  height: 20px;
  padding: 5px;
  background-color: red;
  cursor: pointer;

  svg {
    with: 15px;
    height: 15px;
    color: white;
  }
  &:hover {
    background-color: black;
  }
`;

const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  position: absolute;
  z-index: 2000;
  bottom: 0;
  left: 0;
  padding: 20px;
`;

const configForm = {
  initialValues: {
    contacts: [],
    comment: ""
  },
  validationSchema: yup.object().shape({
    contacts: yup
      .array()
      .of(yup.string().email("Debe ser un correo electrónico válido"))
      .min(1, "Debe agregar al menos un referido")
      .required("Campo requerido"),
    comment: yup.string().required("Campo requerido")
  })
};
